"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppContext = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultContext = {
  userProfile: {},
  isPublic: true,
  getTitle: function getTitle(newTitle) {
    return newTitle;
  }
};

var AppContext = _react.default.createContext(defaultContext);

exports.AppContext = AppContext;


//////////////////
// WEBPACK FOOTER
// ./lib/app/context/AppContext.js
// module id = 74
// module chunks = 0